// removed by extract-text-webpack-plugin
module.exports = {"component":"_2QEyjazz0LjiRrjRDx0vJ3","orderNumber":"NFe7OS3sA7-2kcDoYdBPT","orderStatus":"_2BO__bcduxxGMPChzqYxZd","xiola":"_16mv0B6JekYt8NDwKewNdu","xiolb":"jge1v5pBBCX-KLxRSwXud","xiolc":"_3bAmPwu6tZDpgb2kylvtWX"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PaymentHeader/PaymentHeader.scss
 ** module id = 1007
 ** module chunks = 0
 **/